import { call, put } from 'redux-saga/effects'
import apiMiddleware from 'services/api_middleware'
import app_config from 'config/app_config'

import { ITeamRoleUser } from 'redux/user/types'

import { onOpenNotification } from 'redux/notification/reducer'
import { getUsersFailure, getUsersSuccess } from '../reducer'

export function* getUserListSaga() {
	try {
		const userList: {
			data: { users: ITeamRoleUser[] }
		} = yield call(apiMiddleware, {
			url: app_config.services.getUsers,
		})

		yield put(getUsersSuccess(userList.data.users))
	} catch (e) {
		const error = e as { message: string }

		yield put(
			onOpenNotification({
				message: error.message,
				notificationType: 'error',
			})
		)

		yield put(getUsersFailure())
	}
}
